import {
  beaaPortalProfile,
  matchBeaaAnswer,
  normalizeBeaaText,
  type BeaaAssistantEntry,
} from '@/utils/beaaAssistant';
import { buscarManualSemantico, registrarPerguntaBeaa } from '@/utils/beaaRag';
import { artigoParaEntrada } from '@/utils/beaaManual';

/**
 * Similaridade mínima (cosseno) para a Beaa do cidadão confiar na busca por
 * significado. Abaixo disso, cai no retrocesso por palavra-chave (o guia do
 * portal), evitando responder algo fora do assunto.
 */
const LIMIAR_SEMANTICO_PORTAL = 0.55;

/**
 * Resolve a resposta da Beaa no portal do cidadão usando o MESMO RAG por
 * significado dos manuais — só que restrito aos artigos do ambiente 'portal'
 * (o guia do portal que antes era fixo no código).
 *
 * 1) Tenta por significado (embeddings + pgvector) sobre o guia do portal;
 * 2) Se não tiver confiança, cai no guia por palavra-chave (nada quebra);
 * 3) Se ninguém responder, registra a pergunta como "não sei" para priorizar
 *    novos conteúdos.
 */
export async function resolverRespostaPortal(pergunta: string): Promise<BeaaAssistantEntry> {
  const normalizada = normalizeBeaaText(pergunta);

  if (normalizada) {
    const semanticos = await buscarManualSemantico(pergunta, 4, 'portal');
    const melhor = semanticos?.[0];
    if (melhor && (melhor.similarity ?? 0) >= LIMIAR_SEMANTICO_PORTAL) {
      return artigoParaEntrada(melhor);
    }
  }

  const resposta = matchBeaaAnswer(pergunta, beaaPortalProfile);

  if (resposta.id === beaaPortalProfile.fallback.id) {
    void registrarPerguntaBeaa('portal', normalizada || pergunta.trim(), 'geral');
  }

  return resposta;
}